import React, { useEffect, useState } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import "./themeRegionDiv.css";
import { MdNightlight, MdSunny } from "react-icons/md";
import { SlGlobe } from "react-icons/sl";

const ThemeRegionDiv = (props) => {
  const [isSticky, setIsSticky] = useState(props.isSticky || false);
  const [regionIconClass, setRegionIconClass] = useState("region-text");

  // Optional: mimic `withRouter`
  const location = useLocation();
  const history = useHistory();
  const params = useParams();

  useEffect(() => {
    setIsSticky(props.isSticky);
  }, []);

  useEffect(() => {
    if (props.isSticky !== isSticky) {
      setRegionIconClass(props.isSticky ? "region-text sticky" : "region-text");
      setIsSticky(props.isSticky);
    }
  }, [props]);

  const toggleTheme = (theme) => {
    props.changeTheme(theme);
  };

  const getRegionDivClass = () => {
    let classname = "region-toggle-div";

    if (process.env.REACT_APP_THEMES !== "2") {
      classname += " one-theme";
    }

    if (isSticky) {
      classname += " region-toggle-div-sticky";
    }

    return classname;
  };

  return (
    <div className="theme-region-div">
      {process.env.REACT_APP_THEMES === "2" ? (
        <div className="theme-toggle-div">
          <div className={isSticky ? "background sticky" : "background"}></div>
          {props.theme === "dark" ? (
            <MdNightlight
              className={
                isSticky ? "theme-toggle-icon sticky" : "theme-toggle-icon"
              }
              onClick={() => toggleTheme("light")}
            />
          ) : (
            <MdSunny
              className={
                isSticky ? "theme-toggle-icon sticky" : "theme-toggle-icon"
              }
              onClick={() => toggleTheme("dark")}
            />
          )}
        </div>
      ) : null}

      <div className={getRegionDivClass()}>
        <div className="theme-toggle-div" onClick={props.handleModalOpen}>
          <div className={isSticky ? "background sticky" : "background"}></div>
          <SlGlobe
            className={
              isSticky ? "region-toggle-icon sticky" : "region-toggle-icon"
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ThemeRegionDiv;
